<template>
	<div class="ttable" :class="{'editTable':IsEditTable}">
		<el-table v-loading="tload" element-loading-background="rgba(255, 255, 255, 0.3)" :data="dataCut" ref="Table" border height="95%" highlight-current-row @row-dblclick="rowdbClick"
			@selection-change="selectionChange" @current-change="handleCurrentChange" @select-all="ChooseAll"
			@row-click="RowClick" fit :cell-class-name="cellClass" :row-key="getRowKeys" :row-class-name="rowClass"
			:row-style="RowStyle"
			:key="tableshow" :tree-props="treeProp">
			<template slot="empty">
				<!-- <p> position:absolute;top: 50%;left: 20%;-->
				<span style="font-size: var(--font_small);z-index: 999;font-weight: 200;width: 100%;">
					没有更多数据了
				</span>
				<!-- </p> -->
			</template>
			<!-- 序号 -->
			<el-table-column min-width="160px" style="white-space:nowrap" type="index" label="序号" key="-1"
				align="center" v-if="pagetable.head.length>0"></el-table-column>
			<el-table-column type="selection" label="选择" width="40" :reserve-selection="true" key="-2"
				class-name="ttable_checkbox" :selectable="selectable" align="center"
				v-if="coltype.includes('checkbox')&&pagetable.head.length>0">
			</el-table-column>
			<template v-for="(item,index) in pagetable.head">
				<!-- :width="item.width" -->
				<!-- 列头拖动失效 zoom更改的原因 -->
				<el-table-column :prop="item.name" :label="item.title" style="white-space:nowrap" :key="index"
					:width="item.width" :align="cellAlign&&cellAlign[item.name]?cellAlign[item.name]:'center'"
					:class-name="(item.edit&&cellRender[item.name])?'editCol':(item.title=='规格型号'?'FGSXHCOL':'')"
					:fixed="!!item.fix" v-if="item.hide==undefined||item.hide==false" resizable>
					<!-- elementui有自带的筛选配置 -->
					<template slot="header" slot-scope="{column}">
						{{column.label}}
						<el-dropdown trigger="click" v-if="colfilter||item.isfilter">
							<span class="el-dropdown-link">
								<i class="el-icon-arrow-down"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<div class="tablecoldrop">
									<el-input type="text" v-model="colFilterForm[column.property]"></el-input>
									<table>
										<tr>
											<td @click="comfirFilter(column,1)">确定</td>
											<td @click="comfirFilter(column,0)">重置</td>
										</tr>
									</table>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
						<template v-if="item.IsSort">
							<!-- 排序 -->
							<span class="sort_icon" @click="DoSorts(column.property)">
								<i class="iconfont icon-arrowdown-copy-size" :class="{'disabled':(!sortCols[column.property]),'up':(sortCols[column.property]&&sortCols[column.property]=='up'),
										'down':(sortCols[column.property]&&sortCols[column.property]=='down')
									}"></i>
							</span>
						</template>
					</template>
					<template slot-scope="scope">
						<template v-if="item.edit&&cellRender[item.name]">
							<colitem :row="scope.row" :column="scope.column" :name="cellRender[item.name].name"
								:prop="cellRender[item.name].props||cellRender[item.name].attrs" colType="edit"
								@blur="inputbulr({column:scope.column,row:scope.row,ocol:item})"
								v-if="editClomnRow({column:scope.column,row:scope.row})
									&&(!Object.prototype.hasOwnProperty.call(scope.row,`${item.name}_isEdit`)||scope.row[`${item.name}_isEdit`])" ></colitem>
							<span v-else>{{scope.row[scope.column.property]}}</span>
						</template>
						<template v-else-if="cellshowRender[item.name]">
							<colitem :row="scope.row" :column="scope.column" :name="cellshowRender[item.name].name"
								:prop="cellshowRender[item.name].props"></colitem>
						</template>
						<template v-else>
							{{scope.row[item.name]}}
						</template>
					</template>
				</el-table-column>
			</template>
		</el-table>
		<div style="text-align: center;margin-bottom: 10px;">
			<el-pagination background :layout="tablePSet.layout" :total="tablePSet.datalen"
				@size-change="handleSizeChange" :page-size.sync="tablePSet.pagesize" :page-sizes="tablePSet.pagesizes"
				:current-page.sync="currentPage" @current-change="current_change">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import colitem from './elcolitem.vue';
	var _loop = () => {
		return true;
	}
	export default {
		name: 'elcommTable',
		props: {
			table: {
				type: Object,
				default: () => {}
			},
			coltype: {
				type: String,
				default: 'checkbox' //html渲染
			},
			rowClass: {
				type: Function || String,
				default: () => {
					return 'normal-backcolor';
				}
			},
			RowStyle:{
				type: [Function, Object],
				default: () => {
					return {};
				}
			},
			cellClass: {
				type: Function || String,
				default: () => {
					return 'normal-backcolor';
				}
			},
			tree: {
				type: Boolean,
				default: false
			},
			selectable: {
				type: Function,
				default: _loop
			},
			editClomnRow: {
				type: Function,
				default: () => {
					return true;
				}
			},
			index1: {
				type: String,
				default: 'normal' //html渲染
			},
			ChangeSign: { //控制重新计算列宽
				type: Number,
				default: 0
			},
			colfilter: {
				type: Boolean,
				default: false
			},
			calculate: {
				type: Boolean,
				default: true
			},
			ZWControl: {
				type: Boolean,
				default: false
			}

		},
		watch: {
			ChangeSign(value, old) {
				this.checkColumnChange();
			},
			tload(value){
				this.$emit('loading',value)
			},
			table: {
				handler(value, old) {
					// console.log(value, old)
					if (value.data && value.head) { //强制更新行号等信息
						if (value.head.length > 0) {
							// let {
							// 	currentPage,
							// 	pagesize
							// } = value;
							// currentPage = this.currentPage;
							// var oldarr=[]
							// var newarr=[];
							// if (this.$BH().base.checkNumber(currentPage) && this.$BH().base.checkNumber(pagesize)) {
							// 	if (!currentPage) currentPage = 1;
							// 	newarr = value.data.slice((currentPage - 1) * pagesize, currentPage * pagesize);
							// 	oldarr=old.data.slice((currentPage - 1) * old.pagesize, currentPage * old.pagesize);
							// }
							// // if(this.index1=='diolog'){
							// // 	console.log('---enter',value.data.length>0&&JSON.stringify(newarr)!=JSON.stringify(oldarr)
							// // 	,this.index1)
							// // 	console.log(value,old)
							// // }
							// if(value.data.length>0&&JSON.stringify(newarr)!=JSON.stringify(oldarr)){
							// 	//更新页面的宽度
							// 	this.updateCoulm();
							// }
							// console.log(value.currentPage,old.currentPage)
							if (this.tableshow == 1)
								this.tableshow = Math.random();
						}
					}
				},
				deep: true
			},
			currentPage: {
				handler(value, old) {
					this.updateCoulm();
					this.$forceUpdate();
				}
			},
			// tempTableData:{
			// 	handler(value, old) {
			// 		console.log(value, old)
			// 		// this.$forceUpdate();
			// 	}
			// }
		},
		data() {
			return {
				currentcolf: '',
				colFilterForm: {},
				tableshow: 1,
				currentPage: 1,
				checkList: [],
				allCheck: false,
				updatedaat: 1,

				tempTableData: [],
				filterComfilter: {},
				sortCols: {},
				sortColsDo: {},
				sortTableData: [],
				tload:false,
				
			}
		},
		computed: {
			TColFilter() {
				let isfilter = this.colfilter;
				if (!isfilter) {
					isfilter = this.table.head.filter(item => item.isfilter).length > 0;
				}
				return isfilter;
			},
			treeProp() {
				if (this.tree)
					return {
						children: 'children',
						hasChildren: 'hasChildren'
					};
				return undefined;
			},
			IsEditTable() {
				return !!this.table.head.find(item => item.edit);
			},
			tablePSet() {
				let {
					currentPage,
					pagesize,
					data,
					rowid,
					pagesizes
				} = this.table;
				// console.log(pagesize);
				let seqStartIndex = 1,
					datalen = 0,
					layout = ['total', 'prev', 'pager', 'next', 'sizes', 'jumper'];
				if (window.BH.base.checkNumber(currentPage) && window.BH.base.checkNumber(pagesize)) {
					seqStartIndex = (currentPage - 1) * pagesize;
				}
				if (this.TColFilter && this.tempTableData.length >= 0 && Object.keys(this.filterComfilter).length > 0) {
					//有筛选时
					datalen = this.tempTableData.length;
					// console.log(datalen)
				} else if (data) datalen = data.length;
				if (!pagesize) layout.splice(layout.indexOf('sizes'), 1);
				if (!rowid) rowid = '_id';
				// if (!pagesizes) pagesizes = [15, 30, 45, 60, 75];
				if (!pagesizes) pagesizes = [100, 200, 300, 400, 500];
				console.log(pagesizes)
				layout = layout.join(',');
				return {
					seqStartIndex,
					datalen,
					layout,
					pagesize,
					rowid,
					pagesizes
				}
			},
			dataCut() {
				if (!this.table || (!this.table.data)) return [];
				let {
					currentPage,
					pagesize
				} = this.table;
				console.log(this.table.pagesize)
				currentPage = this.currentPage;
				if (this.$BH().base.checkNumber(currentPage) && this.$BH().base.checkNumber(pagesize)) {
					if (!currentPage) currentPage = 1;
					let tabledata = this.table.data;
					// console.log(this.colfilter && Object.keys(this.filterComfilter).length > 0, Object.keys(this
					// .filterComfilter))
					if (this.TColFilter && this.tempTableData.length >= 0 && Object.keys(this.filterComfilter).length >
						0) {
						//有筛选时
						tabledata = this.tempTableData;
						console.log(tabledata)
					}
					if (Object.getOwnPropertyNames(this.sortColsDo).length > 0) {
						this.DoStrsFn(tabledata);
						tabledata = this.sortTableData;
						// console.log(tabledata)
					}
					let arr = tabledata.slice((currentPage - 1) * pagesize, currentPage * pagesize);
					return arr;
				}
				return [];
			},
			pagetable() {
				let {
					data,
					head
				} = this.table;
				if (!data) data = [];
				if (!head) head = []
				return {
					data,
					head
				};
			},
			cellshowRender() {
				if (this.table.head && this.table.head.length >= 1) {
					let res = {};
					for (let i in this.table.head) {
						if (!this.table.head[i]['edit'] && this.table.head[i]['valueType']) {
							if (this.table.head[i]['dropdata']) {
								res[this.table.head[i]['name']] = {
									name: 'MydropTable',
									props: {
										data: this.table.head[i]['dropdata'],
										valuename: this.table.head[i]['录入值列'],
										filtername: this.table.head[i]['录入值过滤列']
									},
									events: {}
								};
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('bool')) {
								res[this.table.head[i]['name']] = {
									name: '$switch',
									props: {
										disabled: true
									}
								};
							} else res[this.table.head[i]['name']] = undefined;
						} else res[this.table.head[i]['name']] = undefined;
					}
					// console.log(res);
					return res;
				} else return undefined;
			},
			cellAlign() {
				if (this.table.head && this.table.head.length >= 1) {
					let res = {};
					for (let i in this.table.head) {
						if (this.table.head[i]['valueType']) {
							if (this.table.head[i]['valueType'].toLowerCase().includes('string') || this.table.head[
									i]['valueType'].toLowerCase().includes('varchar')) {
								res[this.table.head[i]['name']] = 'left';
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('int')) {
								res[this.table.head[i]['name']] = 'right';
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('decimal')) {
								res[this.table.head[i]['name']] = 'right';
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('double')) {
								res[this.table.head[i]['name']] = 'right';
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('bool')) {
								res[this.table.head[i]['name']] = 'center';
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('date')) {
								res[this.table.head[i]['name']] = 'center';
							} else res[this.table.head[i]['name']] = undefined;
						} else res[this.table.head[i]['name']] = 'left';
						if (this.table.head[i]['name'].includes('日期') ||
							this.table.head[i]['name'].includes('行号')) res[this.table.head[i]['name']] = 'center';
					}
					return res;
				} else return undefined;
			},
			cellRender() { //单元格渲染器 具体的规则设计需要 在project中统一设置 事件和传递的参数渲染
				// if (this.tabletype.includes('edit')) {
				if (this.table.head && this.table.head.length >= 1) {
					let res = {};
					for (let i in this.table.head) {
						if (this.table.head[i]['edit'] && this.table.head[i]['valueType']) {
							if (this.table.head[i]['dropdata']) {
								// console.log(this.table.head[i])
								res[this.table.head[i]['name']] = {
									name: 'MydropTable',
									props: {
										data: this.table.head[i]['dropdata'],
										valueName: this.table.head[i]['valueName'],
										displayName: this.table.head[i]['displayName'],
										filtername: this.table.head[i]['录入值过滤列'],
										itemBoth: this.table.head[i]['itemBoth'],
										disabled: this.table.head[i]['disabled'],
									},
									events: {}
								};
								// console.log(res[this.table.head[i]['name']] )
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('string') || this.table.head[
									i]['valueType'].toLowerCase().includes('varchar')) {
								res[this.table.head[i]['name']] = {
									name: 'input',
									attrs: {
										type: 'text',
										disabled: this.table.head[i]['disabled']
									},
									events: {
										blur: (e) => {
											window.BH.tabletest.call(this, e)
										}
									}
								};
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('int')) {
								res[this.table.head[i]['name']] = {
									name: '$input',
									props: {
										type: 'number',
										min: this.table.head[i]['min'] || '',
										disabled: this.table.head[i]['disabled']
									},
									events: {
										blur: this.inputbulr
									}
								};
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('decimal')) {
								res[this.table.head[i]['name']] = {
									name: '$input',
									props: {
										type: 'number',
										min: this.table.head[i]['min'] || '',
										disabled: this.table.head[i]['disabled']
									},
									events: {
										blur: this.inputbulr
									}
								};
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('bool')) {
								res[this.table.head[i]['name']] = {
									name: '$switch',
									events: {
										change: this.inputbulr
									},
									props: {
										disabled: this.table.head[i]['disabled']
									},
								};
							} else if (this.table.head[i]['valueType'].toLowerCase().includes('date')) {
								res[this.table.head[i]['name']] = {
									name: '$datetime',
									props: {
										format: this.table.head[i]['format'],
										type: this.table.head[i]['valueType'],
										disabled: this.table.head[i]['disabled']
									}
								};
							} else res[this.table.head[i]['name']] = undefined;
						} else res[this.table.head[i]['name']] = undefined;
					}
					console.log(res)
					// if (this.operBtns.length >= 1) { //操作按钮列
					// 	res['操作'] = {
					// 		name: 'MyOpers',
					// 		props: {
					// 			data: this.operBtns
					// 		}
					// 	};
					// }
					return res;
				} else return undefined;
				// } else return {};
			},
		},
		methods: {
			DoStrsFn(dataCut) {
				var doEmpty = (str) => {
					if (str == undefined || str == null) return '';
					return str;
				}
				var isnum = (num) => {
					num = Number(num);
					return isNaN(num) || num == Infinity ? false : true;
				}
				var down = (a, b) => {
					return up(a, b) * -1
				}
				var up = (a, b) => {
					if (isnum(a) && isnum(b)) {
						if (Number(a) == Number(b)) return 0;
						return Number(a) - Number(b) > 0 ? 1 : -1;
					}
					if (String(a) < String(b))
						return -1;
					else if (String(a) > String(b)) return 1;
					else 0;
				}
				for (let i in this.sortColsDo) {
					// console.log(i)
					dataCut.sort((a, b) => {
						let item_a = doEmpty(a[i]);
						let item_b = doEmpty(b[i]);
						if (this.sortColsDo[i] == 'up')
							return up(item_a, item_b);
						if (this.sortColsDo[i] == 'down')
							return down(item_a, item_b);
					});
				}
				// console.log(dataCut)
				this.sortTableData = dataCut;
				// this.$forceUpdate();
			},
			DoSorts(colName) {
				try {
					// console.log(colName)
					if (!this.sortCols[colName]) this.sortCols[colName] = 'down';
					if (this.sortCols[colName] == 'up') this.sortCols[colName] = 'down';
					else if (this.sortCols[colName] == 'down') this.sortCols[colName] = 'up';
					this.sortCols = JSON.parse(JSON.stringify(this.sortCols));
					this.sortColsDo = {};
					this.sortColsDo[colName] = this.sortCols[colName];
					let tempData = JSON.parse(JSON.stringify(this.dataCut));
					this.DoStrsFn(tempData);
					// console.log(this.sortCols,this.$refs['sort'+colName])
					// this.$refs['sort'+colName]&&this.$refs['sort'+colName][0]&&this.$refs['sort'+colName][0].$forceUpdate()

				} catch (e) {
					this.$BH().message(e);
				}
			},
			forUpdate() {
				this.tableshow = Math.random();
			},
			comfirFilter({
				property
			}, sign) {
				if (sign == 1) {
					this.filterComfilter[property] = true;
					this.filterColData();
				} else {
					this.colFilterForm[property] = '';
					delete this.filterComfilter[property];
					delete this.colFilterForm[property];
					this.filterColData();
				}
			},
			filterColData(num) {
				console.log(this.colfilter, this.filterComfilter, this.colFilterForm)
				//根据筛选值进行筛选内容 更改不区分大小写
				if (this.TColFilter && Object.keys(this.filterComfilter).length > 0 && Object.keys(this.colFilterForm)
					.length > 0) {
					let sourceData = this.table.data;
					console.log(sourceData)
					for (let i in this.colFilterForm) {
						sourceData = sourceData.filter((item) => {
							let val = (this.colFilterForm[i]||'').toLowerCase();
							console.log(val)
							if (val && val != '') {
								console.log(((String(item[i])||'').toLowerCase()).indexOf(val) > -1)
								return ((String(item[i])||'').toLowerCase()).indexOf(val) > -1;
							} else return true;
						});
						console.log(sourceData)
					}
					this.tempTableData = sourceData;
					this.currentPage = 1;
					this.$forceUpdate();
				} else {
					this.tempTableData = []
				}
			},
			checkColumnChange() { //页面列的更新直接进行控制
				console.log(this.table.head)
				if (this.table.head.length > 0) {
					//更新页面的宽度
					this.updateCoulm();
				}
			},
			updateCoulm() {
				this.tload=true;
				setTimeout(() => {
					// console.log(this.$refs.Table && this.$refs.Table.$el)
					if (this.$refs.Table && this.$refs.Table.$el) {
						let res = window.BH.base.Dom.elTableFit(this.$refs.Table.$el);
						// console.log(res)
						// if (this.coltype?.includes('checkbox') ||
						// 	this.coltype?.includes('seq')) {
						// 	res = res.slice(1);
						// 	// console.log('3')
						// }
						// console.log('-----updateC')
						if (this.coltype?.includes('checkbox')) {
							res = res.slice(2);
							// console.log('3')
						} else res = res.slice(1);

						let j = 0;
						for (let i in this.table?.head || []) {
							let item = this.table?.head[i];
							if (!item.hide && item.name != '选择' && item.name != '_id' && !item.hide) {
								if(!item.AWidth){
									if(item.name=='规格型号') item.width=120;
									else if(this.colfilter)
										item.width = (res[j]||0)+10;
									else item.width = res[j];
									// console.log(i, item.name, res[j], j);
								}else item.width=item.AWidth;
								
								j += 1;
							}
						}
						let header = JSON.parse(JSON.stringify(this.table?.head || []));
						console.log('---theEnd')
						console.log(this.table?.head)
						this.$emit('FitColumns', header)
						// 不能用这个 tableshow强制刷新 会导致翻页无法选中
						// if(this.coltype?.includes('seq')){
						// }
						// this.tableshow = Math.random();
						// this.$refs.Table.$forceUpdate()
						// console.log('eeee3')
						// console.log('show修改')
					}
					this.tload=false
				}, 400);
			},
			inputbulr({
				column,
				row,
				ocol
			}) {
				console.log({
					column,
					row,
					ocol
				})
				try {
					// console.log(this.calculate)
					if (this.ZWControl) {
						let index = this.table.data.indexOf(row);
						let value = String(row[column.property]) || '';
						for (const char of value) {
							if (char >= '\u4e00' && char <= '\u9fa5') {
								row[column.property] = '';
								this.sendData('changeData', {
									row,
									index
								});
								throw '不允许填写中文字';
							}
						}
					}

					if (this.calculate) {
						let index = this.table.data.indexOf(row);
						let value = row[column.property];
						console.log('----------', index, row)
						window.BH.calculatePrint(row, column.property, value);
						//控制不能
						this.sendData('changeData', {
							row,
							index
						})
					}
					if (ocol && ocol['trigger']) {
						//控制计算当前值
						let label = column.label;
						let currentValue = row[column.property];
						//列字段根据定义的类型替换值
						var hstrReplace = function(sql, row, head) {
							for (let i in head) {
								let labelname = `\\[${head[i].title}\\]`;
								let tvalue = row[head[i].name];
								var regex = new RegExp(labelname, "g");
								head[i]['valueType']=head[i]['valueType']||'string'
								if (String(tvalue) == 'undefined') tvalue = 'null';
								if (head[i]['valueType'].toLowerCase().includes('string') || head[
										i]['valueType'].toLowerCase().includes('varchar')) {
									if (String(tvalue) == 'null') tvalue = `''`;
									else tvalue = `'${tvalue}'`
								} else if (head[i]['valueType'].toLowerCase().includes('int')) {
									tvalue = `cast(${tvalue} as int)`;
								} else if (head[i]['valueType'].toLowerCase().includes('decimal')) {
									tvalue = `cast(${tvalue} as decimal(18,2))`;
								} else if (head[i]['valueType'].toLowerCase().includes('bool')) {
									if (tvalue) tvalue = `cast(1 as bit)`;
									else tvalue = `cast(0 as bit)`;
								} else if (head[i]['valueType'].toLowerCase().includes('date')) {
									if(String(tvalue) == 'null') tvalue = `cast(null as datetime)`;
									else if(tvalue.format) tvalue = `cast('${tvalue.format('yyyy-MM-dd HH:mm:ss')}' as datetime)`;
									else tvalue = `cast('${tvalue}' as datetime)`;
								}
								sql = sql.replace(regex, tvalue);
								// console.log(sql,labelname,tvalue)
							}
							return sql;
						}
						var tcolLoad={}
						var httpcalcute = (format, success) => {
							console.log(this.$BH().ApiUrl)
							$.ajax({
								url: this.$BH().ApiUrl+'Web/ExecFormat',
								async: true,
								data: JSON.stringify({
									format: format
								}),
								type: 'post',
								timeout: 6000,
								dataType: 'json',
								contentType: 'application/json;charset=utf-8',
								success: function(result) {
									console.log(result)
									success(result)
									//$("#div1").html(result);
								},
								error: function(xhr, status) {
									console.log(xhr, status)
									if(Object.keys(format).length>0){
										delete tcolLoad[Object.keys(format)[0]];
										if(Object.keys(tcolLoad).length==0) this.tload=false;
									}
									
								}
							});
						}
						//查看当前 元素下是否有触发的事件
						let trigger = ocol['trigger'];
						for (let i in trigger) {
							let inputType = trigger[i];
							//查找列 指定列的指定方法
							let filter = this.pagetable.head.filter(item => (item.name == i && item.event && item.event[
								inputType]));
							if (filter.length) {
								let tname = filter[0].name;
								let inputInfo = filter[0].event[inputType];
								if (inputType == 'formula') {
									inputInfo = hstrReplace(inputInfo, row, this.pagetable.head);
									this.tload=true;
									tcolLoad[tname]=true;
									httpcalcute({
										[tname]: inputInfo
									}, (res) => {
										let {
											value
										} = res;
										let _tValue = value[i];
										_tValue = 'bit,bool'.includes(filter[0].valueType) ? Boolean(_tValue) :
											_tValue;
										row[tname] = _tValue;
										delete tcolLoad[tname];
										if(Object.keys(tcolLoad).length==0) this.tload=false;
									})
								}
							}
						}
						let index = this.table.data.indexOf(row);
						this.sendData('changeData', {
							row,
							index
						})
					}
				} catch (e) {
					//TODO handle the exception
					if (e && e != "")
						this.$BH().message(e);
					console.log(e)
					this.$forceUpdate()
				}
			},

			clearSelection(e) {
				if (this.$refs && this.$refs.Table) {
					console.log(e)
					if (e) {
						//将选中的值保留下来
						let {
							arr,
							rowid
						} = e;
						if (arr && rowid) {
							this.table.data.forEach(row => {
								for (let i in arr) {
									if (arr[i][rowid] == row[rowid]) {
										this.$refs.Table.toggleRowSelection(row, true)
									} else this.$refs.Table.toggleRowSelection(row, false);
								}
							});
						} else {
							this.allCheck = false;
							this.$refs.Table.clearSelection();
						}

					} else {
						this.allCheck = false;
						this.$refs.Table.clearSelection()
					}
				}
			},
			forupdate() {
				if (this.$refs.Table) this.$refs.Table.$forceUpdate();
				this.$set(this, 'updatedaat', this.updatedaat + 1);
				console.log(this.updatedaat);
			},
			//全选
			ChooseAll(e) {
				let dataArr = this.table.data;
				let isfilter = false;
				if (this.TColFilter && this.tempTableData.length >= 0 && Object.keys(this.filterComfilter).length > 0) {
					//有筛选时
					dataArr = this.tempTableData;
					isfilter = true;
				}
				if (!this.allCheck) {
					console.log('-----筛选', dataArr)
					dataArr.forEach(row => {
						if (this.selectable != _loop) {
							let res = this.selectable(row);
							this.$refs.Table.toggleRowSelection(row, res);
						} else
							this.$refs.Table.toggleRowSelection(row, true)
					});
				} else {
					//如果有筛选条件的话 就全选取消当前筛选结果行
					if (isfilter) {
						console.log('清除行')
						dataArr.forEach(row => {
							this.$refs.Table.toggleRowSelection(row, false)
						});
					} else if (this.$refs && this.$refs.Table)
						this.$refs.Table.clearSelection()
				}
				console.log(this.checkList)
				this.allCheck = !this.allCheck;
			},
			//点击当前行
			handleCurrentChange(currentRow, oldCurrentRow) { //只有更改的时候会触发，获取当前行
				this.$refs.Table.setCurrentRow(currentRow);
			},
			selectionChange(rows) {
				this.checkList = rows;
				//如果有筛选条件的话 就合并筛选之后的选中行
				// if(this.checkList.length==this.table.data.length&&!this.allCheck) this.allCheck=true;
				// console.log(this.selectable)
				// console.log(this.selectable != _loop)
				// if(this.selectable!=_loop){
				// 	if(this.checkList.length>=1){
				// 		this.checkList=[];

				// 	}
				// }
				console.log('选中行', this.checkList)
				this.sendData('checkList', this.checkList)
			},
			//选中当前行
			RowClick(row, column, event) {
				this.sendData('rowClick', row)
			},
			//双击选择
			rowdbClick(row) {
				let {
					rowid
				} = this.tablePSet;
				var SelectState = this.checkList.find(i => i[rowid] == row[rowid]);
				if (SelectState == null) {
					this.$refs.Table.toggleRowSelection(row, true)
				} else {
					this.$refs.Table.toggleRowSelection(row, false)
				}
				this.sendData('rowdbClick', row)
			},
			current_change: function(currentPage) {
				this.currentPage = currentPage;
			},
			getRowKeys(row) {
				// console.log(String(row[this.tablePSet['rowid']]))
				return String(row[this.tablePSet['rowid']]);
			},
			handleSizeChange(val) {
				this.table.pagesize = val;
				this.sendData('sizeChange', val);
				if (this.dataCut.length != this.table.data.length) {
					this.updateCoulm();
					this.$forceUpdate();
				}
			},
			//参数传递
			sendData(name, val) {
				let ChildData = {}
				ChildData[name] = val;
				this.$emit('listenToChild', ChildData);
			},
		},
		components: {
			colitem
		}

	}
</script>

<style>
	.tablecoldrop {
		width: 5rem;
		padding: 0 .3rem;
	}

	.tablecoldrop table {
		width: 100%;
	}

	.tablecoldrop table tr td {
		font-size: var(--font_small);
		text-align: center;
		padding: .2rem .3rem;
	}

	.tablecoldrop table tr td:hover {
		background-color: #F5F7FA;
	}
</style>
<style lang="scss">
	$color_deepblue: #3456bc;
	$color_lightblue: #108EE9;
	$main_color_border: #797979;

	.sort_icon {
		.iconfont {
			font-size: 14px;
			animation: .8s linear ease;
			display: inline-block;

			&.used {
				color: $color_lightblue;
			}

			&.disabled {
				color: $main_color_border;

			}

			&:hover {
				cursor: pointer;
				color: $color_lightblue;
			}

			// 升序
			&.up {
				transform: rotate(180deg);
				color: $color_lightblue;
			}

			&.down {
				color: $color_lightblue;
			}
		}
	}

	.FGSXHCOL .cell {
		white-space: nowrap;
		text-overflow: ellipsis;
	}
</style>